import { isString } from 'lodash-es';
import stringHash from 'string-hash';
import requireAll from './requireAll';
// Require apple touch icons
// doesn't work in node require.context is only supported by webpack
if (process.env.NODE_ENV !== 'test') {
    requireAll(require.context('../assets/images/icons', false, /\.png$/));
}
var MARVEL_ICONS_COUNT = 6;
export default function getRandomIconUrl(projectID) {
    if (!isString(projectID)) {
        throw new Error('Expected "projectID" to be an instance of string');
    }
    var iconType = (stringHash(projectID) % MARVEL_ICONS_COUNT) + 1;
    // eslint-disable-next-line global-require, import/no-dynamic-require
    return require("../assets/images/icons/apple-touch-icon-".concat(iconType, ".png"));
}
